import { Typography } from '@mui/material';
import { FC } from 'react';
import { CustomFormField, SpeciesForm } from '../../../../../api/dtos/dtos';

interface ICustomNoticeMessageProps {
    field: CustomFormField,
    form: SpeciesForm
}

const CustomNoticeMessage: FC<ICustomNoticeMessageProps> = ({
    field
}) => {
    return (
        <Typography
            sx={{ 
                fontStyle: 'italic',
                padding: "10px",

                "li:has(&)": {
                    listStyleType: 'none',
                    margin: '0'
                }
            }}
        >
            {field.meta?.message ?? ""}
        </Typography>
    )
}

export default CustomNoticeMessage